import {
  FETCH_EMPLOYEE_REQUEST,
  FETCH_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_FAILURE,
  FETCH_EMPLOYEE_DETAILS_REQUEST,
  FETCH_EMPLOYEE_DETAILS_SUCCESS,
  FETCH_EMPLOYEE_DETAILS_FAILURE,
  FETCH_EMPLOYEE_OTHER_INFO_REQUEST,
  FETCH_EMPLOYEE_OTHER_INFO_SUCCESS,
  FETCH_EMPLOYEE_OTHER_INFO_FAILURE,
  FETCH_EMPLOYEE_NO_PAY_REQUEST,
  FETCH_EMPLOYEE_NO_PAY_SUCCESS,
  FETCH_EMPLOYEE_NO_PAY_FAILURE,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE,
  FETCH_CDL_ENG_REQUEST,
  FETCH_CDL_ENG_SUCCESS,
  FETCH_CDL_ENG_FAILURE,
  FETCH_CDL_SUP_REQUEST,
  FETCH_CDL_SUP_SUCCESS,
  FETCH_CDL_SUP_FAILURE,
  FETCH_EMPLOYEE_ATTENDANCE_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
} from "../constants/EmpDetailsConstants";

import EmpDetailsService from "../service/EmpDetailsService";

// Fetch employee list for dropdown
export const fetchEmployeeList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_REQUEST });

    const response = await EmpDetailsService.GetEmployeeList();

    dispatch({
      type: FETCH_EMPLOYEE_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMPLOYEE_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch employee list",
    });
  }
};

// Fetch details for selected employee using serviceNo
export const fetchEmployeeDetails = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_DETAILS_REQUEST });

    const response = await EmpDetailsService.GetEmployeeDetails(serviceNo);

    const data = response?.data?.Data?.[0] || null;

    dispatch({
      type: FETCH_EMPLOYEE_DETAILS_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch employee details";

    dispatch({
      type: FETCH_EMPLOYEE_DETAILS_FAILURE,
      payload: errMsg,
    });

    return null;
  }
};

// Fetch other info 
export const fetchEmployeeOtherInfo = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_OTHER_INFO_REQUEST });

    const response = await EmpDetailsService.GetEmployeeOtherInfo(serviceNo);

    dispatch({
      type: FETCH_EMPLOYEE_OTHER_INFO_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMPLOYEE_OTHER_INFO_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch employee other info",
    });
  }
};

// Fetch no pay details
export const fetchEmployeeNoPay =
  (serviceNo, currentYear, startMonth, endMonth, newYear) =>
  async (dispatch) => {
    try {
      dispatch({ type: FETCH_EMPLOYEE_NO_PAY_REQUEST });

      const response = await EmpDetailsService.GetEmployeeNoPay(
        serviceNo,
        currentYear,
        startMonth,
        endMonth,
        newYear
      );

      dispatch({
        type: FETCH_EMPLOYEE_NO_PAY_SUCCESS,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_EMPLOYEE_NO_PAY_FAILURE,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch employee no pay details",
      });
    }
  };

// Fetch previous year summary
export const fetchEmployeePreYearSummary =
  (serviceNo) => async (dispatch) => {
    try {
      dispatch({ type: FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST });

      const response =
        await EmpDetailsService.GetEmployeePreYearSummary(serviceNo);

      dispatch({
        type: FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch employee previous year summary",
      });
    }
  };

  export const fetchCDLEngList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CDL_ENG_REQUEST });

    const response = await EmpDetailsService.GetEmployeeList();

    dispatch({
      type: FETCH_CDL_ENG_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CDL_ENG_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch employee list",
    });
  }
};

export const fetchCDLSupList = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CDL_SUP_REQUEST });

    const response = await EmpDetailsService.GetEmployeeList();

    dispatch({
      type: FETCH_CDL_SUP_SUCCESS,
      payload: response.data.Data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CDL_SUP_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch employee list",
    });
  }
};

export const fetchEmployeeAttendance = (serviceNo, year, month) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMPLOYEE_ATTENDANCE_REQUEST });

    const response = await EmpDetailsService.GetEmployeeAttendanceCard(serviceNo, year, month);

    const data = response?.data?.Data || [];

    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch employee attendance details";

    dispatch({
      type: FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
      payload: errMsg,
    });

    return null;
  }
};